import React, { useState, useEffect } from "react";
import calc from "../../utils/calculation";

import lbl from "../../data/Labels.json";

const FinanceSummaryCard = ({ data, activeYear }) => {
  const [state, setState] = useState({
    paid: 0,
    balance: 0,
  });

  useEffect(() => {
    if (data.data) {
      const fPayments = data?.data.filter(
        (p) => p.half_year_id === (activeYear.half_year_id || activeYear)
      );

      console.log(fPayments);

      let paid = calc.getTotal(fPayments, "amount");
      let balance = paid;

      let _obj = {
        paid,
        balance,
      };

      setState(_obj);
    }
  }, [activeYear]);

  return (
    <div className="summary-card flex">
      <div className="card-wrapper">
        <p className="summary-title">{"خلاصه عمومی"}</p>
        <ul>
          <li>
            <b>{data?.summary?.opening_balance || 0}</b>
            <span>{lbl.OpeningBalance}</span>
          </li>

          <li>
            <b>{data?.summary?.total_paid || 0}</b>
            <span>{lbl.Paid}</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default FinanceSummaryCard;
